/** Optional operation observations. Observers must never change transaction execution. */
export interface TransactionObserver {
    stage?: (stage: "building" | "awaiting_signature" | "signed" | "submitting" | "confirming") => void;
    submitted?: (signature: string) => void;
    failed?: (error: unknown, uncertain: boolean) => void;
}

export function notifyTransaction(observe: (() => void) | undefined): void {
    try {
        observe?.();
    } catch {
        /* Telemetry cannot prevent a transaction. */
    }
}
